import { GlobalTextsProps } from "../interfaces/GlobalInterfaces";

export const globalTexts: GlobalTextsProps = {
    whatsapp: 'https://wa.me/+5491169157750?text=Hola Nidex! Me contacto mediante su pagina. Quiero hacer una consulta.'
}